<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat přesměrování aplikace' | translate" route-name="versionRedirectNew"></add-button>
      <h1 v-translate>Přesměrování aplikací</h1>
    </div>
    <div class="inner_white">
      <div class="status search">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="version-redirect-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in sortingTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sortable="title.sortable"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <version-redirect-row
                v-for="entity in entities"
                :entity="entity"
                :selectedEntities="selectedEntities"
                @input="select"
                :key="entity.id"
                @delete="deleteEntity"
                :ref="'version-redirect-row-ref-'+entity.id"
            />
            <tr v-if="entities.length === 0">
              <td colspan="8" v-translate>Nebyly nalezeny žádné přesměrování aplikací.</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="filteredSelectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="version-redirect-list"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import VersionRedirectRow from "@/components/views/versionRedirect/VersionRedirectRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "VersionRedirects",
  components: {
    VersionRedirectRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'versionRedirects',
      formFields: {
        sort: {
          column: 'sBrand',
          direction: 'asc',
        }
      }
    }
  },
  created(VersionRedirectService) {
    this.entityService = VersionRedirectService
    this.createdInit()
  },
  computed: {
    sortingTableTitles() {
      return [
        {key: 1, name: this.$gettext('Brand'), column: 'sBrand'},
        {key: 2, name: this.$gettext('Typ zařízení'), column: 'sDeviceType'},
        {key: 3, name: this.$gettext('Verze'), column: 'sVersion'},
        {key: 4, name: this.$gettext('Url'), column: 'sUrl', sortable: false},
        {key: 5, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 6, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
      return headers;
    },
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
          errorMessage = message;
      }.bind(this))

      return errorMessage || error['error_message'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/versionRedirect/VersionRedirectList.vue